import Axios from "axios";
import _ from 'lodash'

const state = {
  reports: [],
  currentReport: {}
}

const getters = {
  reports (state) {
    return state.reports
  },

  currentReport (state) {
    return state.currentReport
  }
}

const mutations = {

  addReport (state, report) {
    state.reports.push(report)
  },
  updateReport (state, report) {
    let index = state.reports.findIndex(e => e.id === report.id)
    state.reports.splice(index, 1, report)
  },
  updateReportProperties (state, params) {
    let report  = Object.assign({}, state.currentReport, params)
    _.set(state, 'currentReport', report)
  },
  deleteReport (state, report) {
    let index = state.reports.findIndex(e => e.id === report.id)
    state.reports.splice(index, 1)
  },
  setReports (state, reports) {
    state.reports = reports
  },

  setCurrentReport(state, reportId) {
    let _report = state.reports.find (r => r.id === reportId)
    state.currentReport = _report
  },

}

const actions = {

  async getReports({ commit }) {
    try {
      const payload = await Axios.get('scheduled_reports')
      commit('setReports', payload.data)
    }
    catch (e) {
      return console.log(e)
    }
  },

  async deleteReport({commit}, reportId) {
    try {
      await Axios.delete('/scheduled_reports/' + reportId)
      commit('deleteReport', reportId)
    }
    catch (e) {
      return console.log(e)
    }
  },

  async createReport({commit}, report) {
    try {
      const payload = await Axios.post('/scheduled_reports', {scheduled_report: report})
      commit('addReport', payload.data.report)
    }
    catch (e) {
      return console.log(e)
    }
  },

  async submitUpdateReport({commit}) {
    try {
      let report = Object.assign({}, state.currentReport)
      const payload = await Axios.put(`/scheduled_reports/${report.id}`, {scheduled_report: report})
      commit('updateReport', payload.data.report)
    }
    catch (e) {
      return console.log(e)
    }
  }

}

export default {
  state,
  getters,
  mutations,
  actions
}
